import { CategoryEnum } from '@ingenico/react-configuration-generator';
import type { ReactElement } from 'react';
import { ConfigurationTab } from '../configuration-tab/ConfigurationTab.ctrl';
import { useLogicalDeviceConfigurationTab } from './useLogicalDeviceConfigurationTab.vm';

export interface LogicalDeviceConfigurationTabProps {
  readonly selectedCategory?: CategoryEnum;
  readonly selectedApplicationId?: string;
  readonly onSave?: () => void;
}

export function LogicalDeviceConfigurationTab({
  selectedApplicationId,
  selectedCategory = CategoryEnum.Os,
  onSave,
}: LogicalDeviceConfigurationTabProps): ReactElement {
  const { inputs, logicalDeviceQuery, isEmptyConfiguration, isConfigurationLoading } = useLogicalDeviceConfigurationTab(
    { onSave },
  );

  return (
    <ConfigurationTab
      configurationError={logicalDeviceQuery.error}
      inputs={inputs}
      isConfigurationLoading={isConfigurationLoading}
      isEmptyConfiguration={isEmptyConfiguration}
      selectedApplicationId={selectedApplicationId}
      selectedCategory={selectedCategory}
    />
  );
}
